import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "normalize.css/normalize.css";
import i18n from "@/i18n";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";

// 导入 svgIcon
import SvgIcon from "@/components/SvgIcon/index";
import elementIcons from "@/components/SvgIcon/svgicon";

import { resetForm } from "@/utils/ruoyi";

import directive from "./directive"; // directive

// 图标
const req = require.context("@/assets/icons/svg", false, /\.svg$/);
const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
requireAll(req);

import "@/assets/styles/index.scss";
import "@/permission";

// 注册指令
import plugins from "@/plugins"; // plugins
import elTableInfiniteScroll from "el-table-infinite-scroll";

const app = createApp(App);

// 全局方法挂载
app.config.globalProperties.resetForm = resetForm;

directive(app);

app.use(ElementPlus, { size: "default", zIndex: 3000, locale: zhCn });
app.component("svg-icon", SvgIcon); // 注册全局组件
app.use(plugins);
app.use(elTableInfiniteScroll);
app.use(elementIcons);
app.use(store).use(router).mount("#app");
app.use(i18n);
